module.exports = __webpack_public_path__ + "static/media/send.2631b5ef.svg";